
import { useEffect, useMemo, useState } from "react";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { useEmployeFilter } from "../../../context/EmployeFilterContext";



export const useTimesheetInfo = () => {
    const { selectedEmployee } = useEmployeFilter();
    const [options, setOptions] = useState({
        credits: { enabled: false },
        chart: {
            width: null,
            verticalAlign: 'center',
            // height: 140,
            margin: [-10, 130, 0, 0]
        },
        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: "middle",
            labelFormatter: function () {
                return `${this.name} (${this.hours || '0h'})`;
            }
        },
        title: {
            text: '',
            align: 'center',
            verticalAlign: 'middle',
            y: 50,
            x: -65,
            style: {
                fontSize: 'small',
            },
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
        },
        accessibility: {
            point: {
                valueSuffix: '%',
            },
        },
        plotOptions: {
            pie: {
                showInLegend: true,
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    distance: 10,
                    style: {
                        fontWeight: 'bold',
                        color: 'black',
                        textOutline: 'none',
                        fontSize: '11px'
                    },
                    formatter: function () {
                        if (this.point.y > 0) {
                            return `${this.point.hours}`;
                        }
                    }
                },
                startAngle: -90,
                endAngle: 90,
                center: ['50%', '75%'],
                size: '100%',
            }
        },
        series: [
            {
                type: 'pie',
                name: '',
                innerSize: '80%',
                data: []
            },
        ],
    }
    )
    const [loader, setLoader] = useState(false)





    useEffect(() => {
        if (!_.isEmpty(selectedEmployee)) {
            getMyTimesheetSummary()
        }
    }, [selectedEmployee])

    const getMyTimesheetSummary = async () => {
        const now = new Date();
        setLoader(true);
        const payload = {
            month: now.getMonth() + 1,
            year: now.getFullYear(),
            number_of_month: 0,
            requested_user_code: selectedEmployee?.user_code,
        };
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETWORKLOGCATEGORYTRENDMONTHLYSUMMARY'), payload);
            const simplifiedArray = res?.body?.data?.worklog_category_summary.map(item => {
                return {
                    name: item.issue_type_group_name,
                    y: (item.log_hours === null ? 0 : item.log_hours / item.total_month_hours) * 100,
                    color: item.issue_type_group_color,
                    hours: item.log_hours === null ? "" : item.log_hours + "h",
                    total_log_hours: item?.total_log_hours === null ? 0 : item?.total_log_hours,
                    total_month_hours: item?.total_month_hours === null ? 0 : item?.total_month_hours
                };

            }) || [];

            const total = simplifiedArray.reduce((acc, item) => acc + item.y, 0);

            if (total >= Math.floor(total)) {
                simplifiedArray.push({
                    name: 'Pending',
                    y: 100 - Math.floor(total),
                    color: 'lightgrey',
                    hours: (simplifiedArray[0]?.total_month_hours - simplifiedArray[0]?.total_log_hours) + "h",
                    dataLabels: {
                        enabled: false
                    }
                });
            }
            setOptions(prevState => ({
                ...prevState,
                title: {
                    ...prevState.title,
                    text: `${simplifiedArray[0]?.total_log_hours}h<br>of ${simplifiedArray[0]?.total_month_hours} capacity`,
                },
                series: [
                    {
                        type: 'pie',
                        name: '',
                        innerSize: '80%',
                        data: simplifiedArray,
                    },
                ],
            }));
            setLoader(false);
        } catch (error) {
            console.error(error, "error");
            setLoader(false);
        }
    };

    return useMemo(() => ({
        options, loader
    }), [options, loader])
}